<div class="dialog">
  <span class="dialog-close" (click)="close()">
    <i class="fa fa-close"></i>
  </span>
  <h2 class="dialog-header">{{ modalTitle | translate }}</h2>
  <div class="dialog-content">
    <app-room-type-detail
      [roomType]="roomType"
      [mode]="mode"
      [defaultLanguage]="defaultLanguage"
      [additionalLanguages]="additionalLanguages"
      [isModal]="true"
      (savedRoomType)="onSavedRoomType($event)"
      (canceledRoomType)="onCanceledRoomType()"
    ></app-room-type-detail>
  </div>
</div>
